import { useEffect, useRef } from 'react';
import { useFormikContext } from 'formik';

interface FormikPersistProps<T> {
  registerOnBack?: (callback: () => void) => void;
  onSave: (values: T) => void;
}

/**
 * A component that registers a callback to save form values when navigating back.
 * Must be used inside a Formik context.
 */
export function FormikPersist<T>({ registerOnBack, onSave }: FormikPersistProps<T>) {
  const { values } = useFormikContext<T>();
  const valuesRef = useRef(values);
  const onSaveRef = useRef(onSave);

  useEffect(() => {
    valuesRef.current = values;
  }, [values]);

  useEffect(() => {
    onSaveRef.current = onSave;
  }, [onSave]);

  useEffect(() => {
    if (registerOnBack) {
      registerOnBack(() => onSaveRef.current(valuesRef.current));
    }
  }, [registerOnBack]);

  return null;
}
